import apiCore from "services/apiCore";
import { getCurrentRegion } from "util/envUtils";

const qualityManagementService = {
    createEvaluation(evaluation) {
        return apiCore.v2.post(
            "/quality/conversations/" +
                evaluation.conversation.id +
                "/evaluations",
            evaluation
        );
    },

    getEvaluation(conversationId, evaluationId, options = {}) {
        const { expand = [] } = options;
        return apiCore.v2.get(
            "/quality/conversations/" +
                conversationId +
                "/evaluations/" +
                evaluationId,
            Object.assign({}, options, { expand: expand.join(",") })
        );
    },

    updateEvaluation(conversationId, assignedEvaluationId, assignedEvaluation) {
        return apiCore.v2
            .put(
                "/quality/conversations/" +
                    conversationId +
                    "/evaluations/" +
                    assignedEvaluationId,
                assignedEvaluation
            )
            .then(function (response) {
                return response;
            });
    },

    deleteEvaluation(conversationId, evaluationId, options = {}) {
        const { expand = [] } = options;
        return apiCore.v2.del(
            "/quality/conversations/" +
                conversationId +
                "/evaluations/" +
                evaluationId,
            Object.assign({}, options, { expand: expand.join(",") })
        );
    },

    createCalibration: function (calibration) {
        return apiCore.v2.post("/quality/calibrations", calibration);
    },

    getSurveyUnauthenticated(surveyUrl) {
        const code = surveyUrl.split("surveycodes/")[1].split("?")[0];
        const url = `https://apps.${getCurrentRegion()}/quality-forms/#/surveycodes/${code}`;
        return apiCore.v2.get("/quality/surveys/scorable", {
            customerSurveyUrl: url,
        });
    },

    updateSurveyUnauthenticated(surveyUrl, survey) {
        return apiCore.v2.put("/quality/surveys/scorable", survey, {
            customerSurveyUrl: surveyUrl,
        });
    },

    getSurvey(surveyId, options = {}) {
        const { expand = [] } = options;
        return apiCore.v2.get(
            "/quality/surveys/" + surveyId,
            Object.assign({}, options, { expand: expand.join(",") })
        );
    },
};

export default qualityManagementService;
